export const INDEX_CONSTS = {
  moduleName: 'epb-index',

  getters: {
    jobs: 'jobs',
  },
  actions: {
    getClient: 'getClient',
    listJobs: 'listJobs',
    submitFeed: 'submitFeed',
    reindexFeed: 'reindexFeed',
    reimportJob: 'reimportJob',
    discardJob: 'discardJob',
    downloadFeed: 'downloadFeed',
    updateConfig: 'updateConfig',
  },
  mutations: {
    setClient: 'setClient',
    setJobs: 'setJobs',
  },
}
